import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const RoleManagement = () => {
  return <SingleContentPage title="Role Management" moduleKey="role-management" />;
};

export default RoleManagement;
